var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingArrow2Right(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 26,
    viewBox: "0 0 15 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_215_25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8142 12.9785L1.20115 0L0 1.14516L12.4344 13L5.17759e-05 24.8548L1.2012 26L14.8143 13.0215L14.7917 13L14.8142 12.9785Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20115 0L1.89119 -0.723773L1.20115 -1.38165L0.511114 -0.723773L1.20115 0ZM14.8142 12.9785L15.5042 13.7023L16.2634 12.9785L15.5042 12.2548L14.8142 12.9785ZM0 1.14516L-0.690038 0.421391L-1.4492 1.14516L-0.690038 1.86894L0 1.14516ZM12.4344 13L13.1245 13.7238L13.8836 13L13.1245 12.2762L12.4344 13ZM5.17759e-05 24.8548L-0.689986 24.1311L-1.44914 24.8548L-0.689986 25.5786L5.17759e-05 24.8548ZM1.2012 26L0.511166 26.7238L1.2012 27.3816L1.89124 26.7238L1.2012 26ZM14.8143 13.0215L15.5043 13.7452L16.2635 13.0215L15.5043 12.2977L14.8143 13.0215ZM14.7917 13L14.1017 12.2762L13.3425 13L14.1017 13.7238L14.7917 13ZM0.511114 0.723773L14.1242 13.7023L15.5042 12.2548L1.89119 -0.723773L0.511114 0.723773ZM0.690038 1.86894L1.89119 0.723773L0.511114 -0.723773L-0.690038 0.421391L0.690038 1.86894ZM13.1245 12.2762L0.690038 0.421391L-0.690038 1.86894L11.7444 13.7238L13.1245 12.2762ZM0.690089 25.5786L13.1245 13.7238L11.7444 12.2762L-0.689986 24.1311L0.690089 25.5786ZM1.89124 25.2762L0.690089 24.1311L-0.689986 25.5786L0.511166 26.7238L1.89124 25.2762ZM14.1242 12.2977L0.511166 25.2762L1.89124 26.7238L15.5043 13.7452L14.1242 12.2977ZM14.1017 13.7238L14.1242 13.7452L15.5043 12.2977L15.4817 12.2762L14.1017 13.7238ZM14.1242 12.2548L14.1017 12.2762L15.4818 13.7237L15.5042 13.7023L14.1242 12.2548Z",
    fill: "black",
    mask: "url(#path-1-inside-1_215_25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingArrow2Right);
export default __webpack_public_path__ + "static/media/landingArrow2Right.2dea1b5ff2b6cf2ece328d926eb9c118.svg";
export { ForwardRef as ReactComponent };